import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=bbf3b4ca&scoped=true"
import script from "./paperDetail.vue?vue&type=script&lang=js"
export * from "./paperDetail.vue?vue&type=script&lang=js"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=bbf3b4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3b4ca",
  null
  
)

export default component.exports